import classNames from "classnames";
import { formValidate } from "helpers/form_helper";
import PropTypes from "prop-types";
import React from "react";
import { Controller } from "react-hook-form";
import { Input, Label } from "reactstrap";
import MessageFormValidateV2 from "../MessageFormValidateV2";

/**
 * @param {{
 *  mainForm: any;
 *  fieldName: string;
 *  t: TranslationFunc;
 *  type: import("reactstrap/types/lib/Input").InputType;
 *  isDisabled: boolean;
 *  isRequired: boolean;
 *  title: string;
 *  placeholder:string;
 *  rows: number;
 *  isLabel: boolean;
 *  isPlaintext: boolean;
 *  onChange: (val?: any) => void;
 *  isInputGroup: boolean;
 *  elmGroupAfter: React.ReactNode;
 *  cssInput: Record<string, any>;
 * isFormControlStyle: boolean;
 * }} props
 */
const FormInput = props => {
  const {
    mainForm,
    fieldName,
    t,
    type,
    isDisabled,
    isRequired,
    title,
    rows,
    isLabel,
    isPlaintext,
    onChange,
    isInputGroup,
    elmGroupAfter,
    cssInput,
    placeholder,
    isFormControlStyle,
  } = props;

  /** @type {import("react-hook-form").UseFormReturn} */
  const {
    formState: { errors, touchedFields },
    control,
  } = mainForm;

  return (
    <React.Fragment>
      <div className={`${isLabel ? "mb-3" : ""}`}>
        {isLabel && (
          <Label htmlFor={fieldName}>
            {title || t(`form.${fieldName}`)}{" "}
            {isRequired && <span className="text-danger">*</span>}
          </Label>
        )}
        <div
          className={classNames({
            "input-group": isInputGroup,
          })}
        >
          <Controller
            control={control}
            name={fieldName}
            render={({ field }) => {
              if (isPlaintext) {
                return (
                  <div className="form-control-plaintext">{field.value}</div>
                );
              }

              return (
                <Input
                  {...field}
                  type={type}
                  plaintext={isPlaintext}
                  min={1}
                  readOnly={isPlaintext}
                  disabled={isDisabled}
                  className={`form-control ${
                    isFormControlStyle
                      ? formValidate(errors, touchedFields, fieldName)
                      : ""
                  }`}
                  placeholder={placeholder || title || t(`form.${fieldName}`)}
                  rows={rows}
                  style={cssInput}
                  onChange={data => {
                    field.onChange(data);

                    if (typeof onChange === "function") {
                      onChange(data);
                    }
                  }}
                />
              );
            }}
          />

          {elmGroupAfter && elmGroupAfter}
        </div>
        <MessageFormValidateV2 errors={errors} fieldName={fieldName} />
      </div>
    </React.Fragment>
  );
};

FormInput.propTypes = {
  mainForm: PropTypes.object.isRequired,
  fieldName: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  title: PropTypes.string,
  rows: PropTypes.number,
  isLabel: PropTypes.bool,
  isPlaintext: PropTypes.bool,
  onChange: PropTypes.func,
  isInputGroup: PropTypes.bool,
  elmGroupAfter: PropTypes.element,
  cssInput: PropTypes.object,
  isFormControlStyle: PropTypes.bool,
};

FormInput.defaultProps = {
  isDisabled: false,
  isRequired: false,
  title: "",
  rows: 1,
  isLabel: true,
  isPlaintext: false,
  onChange: () => {},
  isInputGroup: false,
  elmGroupAfter: <span></span>,
  cssInput: {},
  isFormControlStyle: true,
};

export default FormInput;
